import styles, { animationDelays } from "../../constants/styles";
import LinkButton from "./LinkButton";

const Hero = () => {
  return (
    <div className="h-[70vh] flex flex-col justify-center items-center text-center space-y-6">
      <h1
        className={`${styles.primaryHeading} slideFromBottom`}
        style={animationDelays.delay2}
      >
        Chrome Extension
      </h1>
      <h2
        className={`${styles.tertiaryHeading} slideFromBottom`}
        style={animationDelays.delay3}
      >
        Easily download your duolingo words.
      </h2>
      <LinkButton />
    </div>
  );
};

export default Hero;
